import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, Router } from "@angular/router";
import { UserStore } from "../user/store/user.store";

import { UserRole } from "../user/enum/user-role.enum";
import { firstValueFrom, forkJoin } from "rxjs";

export const RoleGuard: CanActivateFn = async (
    route: ActivatedRouteSnapshot
  ) => {
    const userStore = inject(UserStore);
    const router = inject(Router);
  
    const requiredRoles = route.data['roles'] as UserRole[] ?? [];
  
    if(userStore.roles().length === 0) {
      await firstValueFrom(
        forkJoin({
          roles: userStore.loadRolesObs(),
          user: userStore.loadUserObs(),
        }));
    }

    if (!userStore.hasAnyRole(requiredRoles)) {
      router.navigate(['/unauthorized']); 
      return false;
    }
  
    return true;
  
  };